import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private url = environment.api;
  constructor(
    private http: HttpClient,
  ) { }

  getSvg(nameSvg: string): Observable<Document> {
    return this.http.get('assets/img/c' + nameSvg + '.svg', { responseType: 'text' })
      .pipe(
        map(svgText => {
          const parser = new DOMParser();
          return parser.parseFromString(svgText, 'image/svg+xml');
        })
      );
  }

  getImageDataUrl(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      switchMap(imageBlob => {
        return new Observable<string>(observer => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (typeof reader.result === 'string') {
              observer.next(reader.result);
              observer.complete();
            } else {
              observer.error(new Error('Failed to convert image blob to data URL'));
            }
          };
          reader.readAsDataURL(imageBlob);
        });
      })
    );
  }

  saveEditableInfo(dataEditable: any) {
    return this.http.post(this.url + "api/erp/inventory/warehouse/editable", dataEditable);
  }

  getCertifierData(serie:number, number:number) {
    return this.http.get(this.url + `api/erp/sale/invoices/felData?serie=${serie}&number=${number}`);
  }
}
